import { de as de$1 } from 'date-fns/locale';

var de = {
  formats: {
    date: "dd.mm.yyyy",
    dateMonth: "mm.yyyy",
    dateLocale: de$1,
    quotationMarkOpening: "„",
    quotationMarkClosing: "“"
  },
  texts: {
    lsg: {
      component: {
        _general: {
          optional: "Optional"
        },
        BankingCard: {
          titles: {
            giro: "Girocard",
            giro_old: "Girocard",
            info: "Infocard",
            spar: "Sparcard",
            flexi: "Flexicard",
            einzahl: "Einzahlcard"
          },
          cardNumber: "Karten-Nr.",
          validThru: "Gültig bis"
        },
        BreadCrumbs: {
          title: "Seitenhierarchie"
        },
        CcsApprovalPanel: {
          layerBackButton: "Zurück",
          technicalErrorTitle: "Technischer Fehler",
          technicalErrorSubtitle: "Diese Funktion steht wegen eines technischen Fehlers nicht zur Verfügung.",
          cancelButton: "Abbrechen"
        },
        ClickList: {
          selected: "Ausgewählt"
        },
        ComplexTable: {
          sortAscending: "Aufsteigend sortieren",
          sortDescending: "Absteigend sortieren",
          sortedAscending: "Aufsteigend sortiert",
          sortedDescending: "Absteigend sortiert",
          labelSortLayer: "Sortierung nach",
          labelSortLayerBackButton: "Zurück",
          labelSortMenu: "Sortierung"
        },
        ContentWrapper: {
          closeLayer: "zurück zur Übersicht",
          showDetails: "Details anzeigen"
        },
        Feedback: {
          trueButton: "Ja",
          falseButton: "Nein",
          result: "Vielen Dank für Ihr Feedback."
        },
        Footer: {
          claim: "Die Bank an Ihrer Seite"
        },
        Header: {
          myBanking: "Mein Banking",
          search: "Suche",
          openMenu: "Menü öffnen",
          closeDrawer: "Menü schließen"
        },
        IconLink: {
          defaultAriaLabel: "Button mit {{label}} Symbol"
        },
        InputDatepicker: {
          placeholder: "TT.MM.JJJJ",
          placeholderMonthYear: "MM.JJJJ",
          label: "Datum",
          error: "Bitte geben Sie ein gültiges Datum im Format {{format}} ein.",
          openCalendar: "Kalender öffnen",
          nextMonth: "nächster Monat",
          previousMonth: "vorheriger Monat",
          nextYear: "nächstes Jahr",
          previousYear: "vorheriges Jahr"
        },
        InputSelect: {
          error: "Bitte wählen Sie eine Option aus.",
          open: "Auswahlfeld öffnen",
          close: "Auswahlfeld schließen",
          empty: "Keine Einträge"
        },
        InputTextfield: {
          clear: "Eingabe löschen",
          reveal: "Passwort anzeigen"
        },
        InputSearch: {
          placeholder: "Suche",
          clear: "Suche zurücksetzen"
        },
        Logo: {
          title: "Unternehmenslogo",
          titleCoba: "Commerzbank Logo",
          actionHome: "Zur Unternehmensstartseite"
        },
        OnPageNavigation: {
          backtoTop: "Zum Seitenanfang"
        },
        ProcessHeader: {
          openMenu: "Menü öffnen"
        },
        ProfileWidget: {
          closeMenu: "Zurück",
          logout: "Abmelden"
        },
        ProfileButton: {
          login: "Anmelden"
        },
        SideNavigation: {
          openMenu: "Menü öffnen",
          closeMenu: "Menü schließen"
        },
        SliderPagination: {
          nextPage: "nächste Seite",
          previousPage: "vorherige Seite",
          pagination: "Seitenauswahl"
        },
        Stage: {
          scrollerText: "Hier weiterlesen..."
        },
        Video: {
          replay: "Erneut abspielen",
          notSupported: "Ihr Browser kann dieses Video nicht wiedergeben.",
          play: "Abspielen",
          pause: "Pause",
          mute: "Stummschalten",
          unMute: "Ton einschalten",
          fullScreen: "Vollbild ein- und auschalten",
          captionOn: "Untertitel an",
          captionOff: "Untertitel aus"
        }
      },
      icon: {
        _default: "Icon",
        banking_card_addCard: "Karte hinzufügen",
        banking_card_appleWallet: "Apple Wallet",
        banking_card_blockCard: "Karte blockieren",
        banking_card_multipleCards: "Mehrere Karten",
        banking_card_singleCard: "Einzelne Karte",
        banking_card_wrongPayment: "Ungültige Zahlung",
        banking_cash_3Coins: "Münzen Euro",
        banking_cash_banknoteEur: "Banknote Euro",
        banking_cash_banknoteUsd: "Banknote US Dollar",
        banking_cash_coinArrowleft: "Pfeil auf Euro Münze",
        banking_cash_coinArrowright: "Pfeil von Euro Münze",
        banking_cash_coinBtc: "Münze Bitcoin",
        banking_cash_coinEur: "Münze Euro",
        banking_cash_coinstack: "Münzenstapel",
        banking_graphs_benchmark: "Balkendiagramm",
        banking_graphs_graph: "Liniendiagramm",
        banking_graphs_piechart: "Kuchendiagramm",
        banking_transfer_standingOrder: "Ausstehende Order",
        banking_transfer_transferRebooking: "Zurückbuchung",
        banking_transfer_transferReceive: "Buchung erhalten",
        banking_transfer_transferRecurring: "Wiederkehrende Buchung",
        banking_transfer_transferScheduled: "Geplante Buchung",
        banking_transfer_transferStandard: "Buchung",
        banking_transfer_transferslip: "Scheck Buchung",
        banking___3rateCredit: "3-Raten-Kredit",
        banking___atm: "Geldautomat",
        banking___bank: "Bank",
        banking___cashradar: "Radar",
        banking___cobaMultichannel: "Commerzbank Multikanal",
        banking___contactless: "Kontaktlos",
        banking___gem: "Edelstein",
        banking___giropayP2p: "Giropay",
        banking___goldbars: "Goldbarren",
        banking___handMoney: "Hand mit Münze",
        banking___handsMoney: "Hände mit Euro Münze",
        banking___mobileEuro: "Euro mobil",
        banking___multibanking: "Multibanking",
        banking___phototan: "Foto Tan",
        banking___piggybank: "Sparschwein",
        banking___pincode: "Pin Code",
        banking___vault: "Tresor",
        brands_banks_comdirect: "Logo Comdirect",
        brands_banks_commerzbank: "Logo Commerzbank",
        brands_banks_deutschebank: "Logo Deutsche Bank",
        brands_banks_ing: "Logo ING",
        brands_banks_n26: "Logo N26",
        brands_banks_postbank: "Logo Postbank",
        brands_banks_sparkasse: "Logo Sparkasse",
        brands_banks_targo: "Logo Targobank",
        brands___apple: "Logo Apple",
        brands___google: "Logo Google",
        brands___visa: "Logo Visa",
        communication_feedback_agreement: "Handschlag",
        communication_feedback_dislike: "Gefällt mir nicht",
        communication_feedback_happy: "Glücklich",
        communication_feedback_like: "Gefällt mir",
        communication_feedback_neutral: "Neutral",
        communication_feedback_sad: "Traurig",
        communication___call: "Anruf",
        communication___chat: "Chat",
        communication___envelope: "Briefumschlag",
        communication___handPointing: "Handzeiger",
        communication___handHeart: "Hand zeigt auf Herz",
        communication___handsCare: "Hände Sorgfalt",
        communication___inbox: "Posteingang",
        communication___news: "Nachrichten",
        communication___recommendation: "Empfehlung",
        communication___textchat: "Textchat",
        communication___videochat: "Videochat",
        interaction_arrows_arrowDown: "Pfeil nach unten",
        interaction_arrows_arrowLeft: "Pfeil nach links",
        interaction_arrows_arrowLeftright: "Pfeil links rechts",
        interaction_arrows_arrowRight: "Pfeil nach rechts",
        interaction_arrows_arrowUp: "Pfeil nach oben",
        interaction_arrows_chevronDown: "Indikator nach unten",
        interaction_arrows_chevronLeft: "Indikator nach links",
        interaction_arrows_chevronRight: "Indikator nach rechts",
        interaction_arrows_chevronUp: "Indikator nach oben",
        interaction___add: "Hinzufügen",
        interaction___backToTop: "Zurück nach oben",
        interaction___bluetoothOn: "Bluetooth eingeschaltet",
        interaction___checkmark: "Bestätigen",
        interaction___close: "Schließen",
        interaction___copy: "Kopieren",
        interaction___dashLong: "Langer Strich",
        interaction___dashShort: "Kurzer Strich",
        interaction___download: "Herunterladen",
        interaction___eyeHide: "Verstecken",
        interaction___eyeView: "Anzeigen",
        interaction___filter01: "Filtern",
        interaction___filter02: "Filtern",
        interaction___fingerprint: "Fingerabdruck",
        interaction___flashOff: "Blitz ausgeschaltet",
        interaction___flashOn: "Blitz eingeschaltet",
        interaction___fullscreenEnter: "Bildschirmfüllend an",
        interaction___fullscreenExit: "Bildschirmfüllend aus",
        interaction___history: "Historie",
        interaction___logout: "Abmelden",
        interaction___menu: "Menu",
        interaction___more01: "Mehr",
        interaction___more02: "Mehr",
        interaction___notificationOff: "Benachrichtigungen aus",
        interaction___notificationOn: "Benachrichtigungen an",
        interaction___pause: "Pause",
        interaction___playbutton: "Abspielen",
        interaction___refresh: "Neu laden",
        interaction___replay: "Erneut abspielen",
        interaction___save: "Speichern",
        interaction___search: "Suchen",
        interaction___share: "Teilen",
        interaction___slider: "Einstellungen",
        interaction___trash: "Löschen",
        interaction___uploadCloud: "Hochladen Cloud",
        interaction___upload: "Hochladen",
        interaction___volumeLow: "Lautstärke leise",
        interaction___volumeOff: "Lautstärke aus",
        interaction___volume: "Lautstärke",
        interaction___wifiOff: "WLAN ausgeschaltet",
        interaction___wifiOn: "WLAN eingeschaltet",
        location___cobaTower: "Commerzbank Hochhaus",
        location___direction: "Wegweiser",
        location___globe: "Globus",
        location___house: "Haus",
        location___location: "Ort",
        location___office: "Büro",
        location___target: "Ziel",
        object_devices_calculator: "Taschenrechner",
        object_devices_camera: "Kamera",
        object_devices_headset: "Headset",
        object_devices_keyboard: "Tastatur",
        object_devices_laptop: "Laptop",
        object_devices_microphone: "Mikrofon",
        object_devices_printer: "Drucker",
        object_devices_responsive: "Geräte bedarfsgesteuert",
        object_devices_smartphone: "Smartphone",
        object_devices_tablet: "Tablet",
        object_devices_video: "Video",
        object_document_certificate: "Zertifikat",
        object_document_checklist: "Checkliste",
        object_document_document: "Dokument",
        object_document_documentMinus: "Dokument entfernen",
        object_document_documentPlus: "Dokument hinzufügen",
        object_document_folderOpen: "Ordner offen",
        object_document_questionnaire: "Fragebogen",
        object_document_signature: "Unterschrift",
        object_nature_bug: "Käfer",
        object_nature_cloud: "Cloud",
        object_nature_sprout: "Spross",
        object_shieldCheckmark: "Schild mit Haken",
        object_transport_airplane: "Flugzeug",
        object_transport_automobile: "Auto",
        object_transport_campervan: "Camper",
        object_transport_caravan: "Karavan",
        object_transport_motorcycle: "Motorrad",
        object_transport_pram: "Kinderwagen",
        object_transport_trailer: "Anhänger",
        object_transport_train: "Zug",
        object_transport_wheel: "Rad",
        object___alarmclock: "Wecker",
        object___bug: "Käfer",
        object___book: "Buch",
        object___briefcase: "Aktentasche",
        object___calender: "Kalender",
        object___clock: "Uhr",
        object___coffeemug: "Kaffeetasse",
        object___compass: "Kompass",
        object___firstaid: "Erste Hilfe",
        object___flag: "Flagge",
        object___gauge: "Tacho",
        object___gear: "Zahnrad",
        object___groceries: "Lebensmittel",
        object___key: "Schlüssel",
        object___knifeFork: "Messer und Gabel",
        object___lightbulb: "Glühbirne",
        object___lock: "Schloss",
        object___lockOpen: "Schloss offen",
        object___paperclip: "Büroklammer",
        object___pencil: "Stift",
        object___rockingChair: "Schaukelstuhl",
        object___shieldCheckmark: "Schild mit Haken",
        object___shoppingcart: "Einkaufswagen",
        object___sofa: "Sofa",
        object___snowflake: "Schneeflocke",
        object___snowflakeAttention: "Schneeflocke mit Ausrufezeichen",
        object___noSnowflake: "Schneeflocke durchgestrichen",
        object___stopwatch: "Stoppuhr",
        object___sprout: "Sprössling",
        object___suitcase: "Koffer",
        object___sun: "Sonne",
        object___tag: "Preisschild",
        object___torch: "Taschenlampe",
        object___umbrella: "Regenschirm",
        object___wrench: "Zange",
        people___businessMale: "Geschäftsmann",
        people___callcenter: "Callcenter",
        people___childFemale: "Mädchen",
        people___childMale: "Junge",
        people___female: "Frau",
        people___fullbodyFemale: "Körper Frau",
        people___fullbodyMale: "Körper Mann",
        people___fullbodyProfile: "Körper Profil",
        people___groupFemale: "Frauen",
        people___groupMale: "Männer",
        people___hipsterMale: "Hipster Mann",
        people___male: "Mann",
        people___photoId: "Ausweis",
        people___privacySpy: "Spion",
        people___profileAdd: "Profil hinzufügen",
        people___profileAttention: "Profilbild mit Ausrufezeichen",
        people___profileHistory: "Profil Historie",
        people___profile: "Profil",
        people___teacherPresent: "Lehrer anwesend",
        people___teamFemale: "Team Frau",
        people___teamMale: "Team Mann",
        people___wheelchair: "Rollstuhl",
        social___cobablog: "Commerzbank Blog",
        social___facebook: "Facebook",
        social___instagram: "Instagram",
        social___linkedin: "LinkedIn",
        social___pinterest: "Pinterest",
        social___tiktok: "TikTok",
        social___twitter: "Twitter",
        social___xing: "Xing",
        social___youtube: "YouTube",
        symbols___asterisk: "Sternchen",
        symbols___at: "At-Zeichen",
        symbols___blockchain: "Blockchain",
        symbols___digitalisation: "Digitalisierung",
        symbols___error: "Fehler",
        symbols___exclamationmark: "Ausrufezeichen",
        symbols___heart: "Herz",
        symbols___infoCircle: "Info Kreis",
        symbols___info: "Info",
        symbols___legal: "Paragraphen",
        symbols___music: "Musik",
        symbols___percentage: "Prozent",
        symbols___questionmarkCircle: "Fragezeichen Kreis",
        symbols___questionmark: "Fragezeichen",
        symbols___quotationmark: "Anführungszeichen",
        symbols___slashCircle: "Schrägstrichkreis",
        symbols___uncategorized: "Keine Kategorie"
      }
    }
  }
};

export { de };
